import request from '@/axios'


export function platformModuleslist () {
  return request({
    url: '/communication_related_modules',
    method: 'GET'
  })
}

export function getFilteredPlatformModules () {
  return request({
    url: '/communication/email/fetch_module',
    method: 'GET'
  })
}

export function getRelatedRecords (payload) {
  return request({
    url: '/communication/email/fetch_module_record',
    method: 'POST',
    data: payload
  })
}

export function communicationTypeList (customer_id, platform_module_id) {
  return request({
    url: `/communication/type/list/${customer_id}/${platform_module_id}`,
    method: 'GET'
  })
}


export function emailTemplateShow (customer_id, template_id) {
  return request({
    url: `/communication/template/show/${customer_id}/${template_id}/EMAIL`,
    method: 'GET'
  })
}

export function emailTemplateList (sorting_obj, table_name, payload, customer_id, page, limit) {
  let url = ''
  if (Object.entries(sorting_obj).length > 0) {
    url = `V1/communication/email/user_defined_template/list/${customer_id}?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}&limit=${limit}`
  } else {
    url = `V1/communication/email/user_defined_template/list/${customer_id}?&table_name=${table_name}&page=${page}&limit=${limit}`
  }
  return request({

    url,
    method: 'POST',
    data:payload
  })
}


export function emailDynamicFieldList (platform_modules_id, customer_id) {
  return request({
    url: `/communication/template/list_template_string/${platform_modules_id}/${customer_id}`,
    method: 'GET'
  })
}

export function emailTypeList () {
  return request({
    url: '/emailType/list',
    method: 'GET'
  })
}

export function emailTemplateCreate (customer_id, query) {
  return request({
    url: `/V1/communication/email/user_defined_template/create/${customer_id}`,
    method: 'POST',
    data: query
  })
}

export function emailTemplateEdit (customer_id, template_id, query) {
  return request({
    url: `V1/communication/email/user_defined_template/update/${customer_id}/${template_id}`,
    method: 'POST',
    data: query
  })
}

export function emailMapFields (customer_id, query) {
  return request({
    url: `/communication/map/fields/${customer_id}/EMAIL`,
    method: 'POST',
    data: query
  })
}

export function emailTemplateDelete (customer_id, query) {
  return request({
    url: `V1/communication/email/user_defined_template/delete/${customer_id}`,
    method: 'POST',
    data: query
  })
}

export function emailSignatureList (sorting_obj, table_name, payload, customer_id, page, limit) {
  let url = ''
  if (Object.entries(sorting_obj).length > 0) {
    url = `V1/communication/email/signs/list/${customer_id}?attribute=${sorting_obj.attribute}&direction=${sorting_obj.direction}&field_type=${sorting_obj.field_type}&table_name=${table_name}&page=${page}&limit=${limit}`
  } else {
    url = `V1/communication/email/signs/list/${customer_id}?&table_name=${table_name}&page=${page}&limit=${limit}`
  }
  return request({
    url,
    method: 'POST',
    data:payload
  })
}

export function emailSignatureCreate (customer_id, query) {
  return request({
    url: `/V1/communication/email/signs/create/${customer_id}`,
    method: 'POST',
    data: query
  })
}

export function emailSignatureEdit (customer_id, template_id, query) {
  return request({
    url: `V1/communication/email/signs/update/${customer_id}/${template_id}`,
    method: 'POST',
    data: query
  })
}

export function emailSignatureDelete (customer_id, query) {
  return request({
    url: `V1/communication/email/signs/delete/${customer_id}`,
    method: 'POST',
    data: query
  })
}

export function emailTemplateEditfromCommunication (customer_id, template_id, query) {
  return request({
    url: `/communication/template/edit/${customer_id}/EMAIL/${template_id}`,
    method: 'POST',
    data: query
  })
}

export function emailTemplateCreatefromCommunication (customer_id, query) {
  return request({
    url: `/communication/template/create/${customer_id}/EMAIL`,
    method: 'POST',
    data: query
  })
}